import graphql from 'babel-plugin-relay/macro';

/**
 * Fragments
 */
export const REQUESTS_FRAGMENT = graphql`
  fragment requestsFragment on EventRequest {
    id
    contact {
      ...contactFragment
    }

    account {
      ...accountBaseFragment
    }

    preferredPractitioner {
      ...userProfileBaseFragment
      ...userProfileNameFragment
    }

    event {
      ...eventFragment
    }
    comment
    createdAt
  }
`;

export const REQUESTS_INLINE_FRAGMENT = graphql`
  fragment requestsInlineFragment on EventRequest @inline {
    id
    contact {
      ...contactInlineFragment
    }

    account {
      ...accountBaseInlineFragment
    }

    preferredPractitioner {
      ...userProfileBaseInlineFragment
      ...userProfileNameInlineFragment
    }

    event {
      ...eventInlineFragment
    }
    comment
    createdAt
  }
`;

export const REQUESTS_REFETCHABLE_FRAGMENT = graphql`
  fragment requestsRefetchableFragment on Query @refetchable(queryName: "requestsRefetchableQuery") {
    eventRequests(first: $first, after: $after, ordering: $ordering, filter: $filter)
      @connection(key: "connection_eventRequests") {
      __id
      count
      edges {
        node {
          ...requestsFragment
          ...requestsInlineFragment
        }
      }
    }
  }
`;

export const REQUESTS_QUERY = graphql`
  query requestsQuery($first: Int!, $after: String, $ordering: [EventRequestOrdering!], $filter: EventRequestFilter) {
    ...requestsRefetchableFragment
  }
`;

export const REQUEST_QUERY = graphql`
  query requestQuery($id: ID!, $skip: Boolean = false) {
    eventRequest(id: $id) @skip(if: $skip) {
      ...requestsFragment
    }
  }
`;

export const REQUEST_UPDATE_REQUEST_MUTATION = graphql`
  mutation requestUpdateRequestMutation($id: ID!, $input: EventRequestUpdateInput!) {
    updateEventRequest(id: $id, input: $input) {
      eventRequest {
        ...requestsFragment
      }
    }
  }
`;

export const REQUEST_DECLINE_REQUEST_MUTATION = graphql`
  mutation requestDeclineRequestMutation($connections: [ID!]!, $id: ID!, $input: EventRequestDeclineInput!) {
    declineEventRequest(id: $id, input: $input) {
      id @deleteEdge(connections: $connections)
    }
  }
`;

export const REQUEST_DELETE_REQUEST_MUTATION = graphql`
  mutation requestDeleteRequestMutation($connections: [ID!]!, $id: ID!) {
    deleteEventRequest(id: $id) {
      id @deleteEdge(connections: $connections)
    }
  }
`;
